import axios from "axios";
import { ValidationError } from "api/block/types";
import { mapValidationErrorGeneralMessagesToString } from "api/block/mapper";
import { EntityIdentifier } from "module/entity/types";

interface BlockResponse {
  validationError?: ValidationError;
  validationGeneralError: string[];
}

const block = async (entities: EntityIdentifier[]): Promise<BlockResponse> => {
  let validationError;
  let validationGeneralError: string[] = [];
  try {
    await axios.post(`/api/block-entities`, { entities });
  } catch (error) {
    if (error.response.status === 422) {
      validationError = error.response.data;
      validationGeneralError =
        mapValidationErrorGeneralMessagesToString(validationError);
    } else {
      throw new Error(error);
    }
  }
  return {
    validationError,
    validationGeneralError,
  };
};

export default block;
